export default __webpack_public_path__ + "static/media/tech.015306f5.svg";